import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { AppDispatch } from "store/store";
import rollbar from "helpers/rollbar";
import { updateGeneralForm } from "store/platforms/slice";
import { DestinationDescriptor } from "views/page-content/platforms/platform/simulcast/types";
import { PlatformSubsettingsBase } from "../PlatformSubsettingsBase";
import { Spinner } from "components/spinners/Spinner";
import { PlatformId } from "views/page-content/platforms/types";
import { useSwitcherClient } from "hooks/useSwitcherClient";
import { useTranslation } from "react-i18next";

export const RtmpPlatformSettings = ({
    advanceStep
}: {
    advanceStep: () => void;
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const { generalForm } = useSelector(
        (state: RootState) => state.platforms.general
    );

    const [loading, setLoading] = useState(true);

    const { data: destinations } = useSwitcherClient(
        (client) => client.switcherStreamSettings_GetAllSwitcherStudioSettings,
        {
            requestImmediately: true,
            preFetch: () => setLoading(true),
            onSuccess: () => setLoading(false),
            onError: (error) => {
                rollbar.error(
                    "Error getting and setting simulcast rtmp destinations",
                    error
                );

                setLoading(false);
            }
        }
    );

    const saveDestination = useCallback(
        (destination: DestinationDescriptor) => {
            const newSelectedDests = [
                ...generalForm.selectedSimulcastDestinations.filter(
                    (d) => d.id !== destination.id
                ),
                destination
            ];

            dispatch(
                updateGeneralForm({
                    selectedSimulcastDestinations: newSelectedDests
                })
            );

            advanceStep();
        },
        [dispatch, generalForm.selectedSimulcastDestinations, advanceStep]
    );

    if (loading) {
        return <Spinner />;
    }

    return (
        <div>
            <PlatformSubsettingsBase
                destinations={destinations
                    .filter((a) => a["user-editable"])
                    .map((d) => ({
                        ...d,
                        id: d["switcher-stream-setting-id"],
                        isDisabled:
                            generalForm.selectedSimulcastDestinations.some(
                                (dest) =>
                                    dest.id === d["switcher-stream-setting-id"]
                            )
                    }))}
                imgSrcKey={""}
                destinationNameKey="channel-name"
                onDestinationClick={saveDestination}
                platformId={PlatformId.Rtmp}
                headingText={t("platforms:channels")}
            />
        </div>
    );
};
